import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem, MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { ImportOrderGateway } from 'src/app/application/gateway/ImportOrderGateway';
import { ImportOrderInformation } from 'src/app/domain/models/ImportOrder';
import { BasicUser } from 'src/app/domain/models/User';
import { Routes } from 'src/app/infrastructure/routes';

@Component({
  selector: 'app-admin-order-management',
  templateUrl: './admin-order-management.component.html',
  styleUrls: ['./admin-order-management.component.css'],

})
export class AdminOrderManagementComponent {
  breadcrumbMenuItems: MenuItem[] = []
  breadcrumbHome: MenuItem = {}
  tabActiveIndex: number = 0;

  orderId: any
  order: ImportOrderInformation | undefined
  profile: BasicUser | undefined
  paidRegistered: boolean = true

  constructor(
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _authService: AuthGateway,
    private readonly _importOrderService: ImportOrderGateway,
    public readonly translate: TranslateService
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.orderId = params['orderId']
    })
  }

  ngOnInit(): void {
    if (this.orderId) {
      this.profile = this._authService.getUser()
      if (this.profile) this.translate.use(this.profile.lang)

      this.loadBreadcrumb();
      this.loadImportOrder();
    }
  }

  loadBreadcrumb() {
    this.translate.get([
      'AdminOrderDetailManagement.Order.PageTitle',
      'AdminOrderDetailManagement.PageHomeText',
    ]).subscribe({
      next: (translations) => {
        this.breadcrumbHome = {
          label: translations['AdminOrderDetailManagement.Order.PageTitle'],
          routerLink: ['/' + Routes.adminManageOrderPage]
        }
        this.breadcrumbMenuItems = [{
          label: translations['AdminOrderDetailManagement.PageHomeText']
        }]
      },
      error: () => {}
    })
  }

  loadImportOrder() {
    this._importOrderService.getById(this.orderId).subscribe({
      next: (v) => {
        this.order = v
      },
      error: (_) => {}
    })
  }
}
